<mat-card class="card gedcom-card">
    <mat-card-content>
        <p i18n class="mat-card-header">Select GEDCOM</p>
        <div class="content">

            <div class="info-text-container">
                <p i18n class="bold">Info:</p>
                <p i18n class="info-text">
                    Upload your GEDCOM file here or try one of our official GEDCOM files. Please note that the upload
                    time may vary depending on the file's size and complexity. Easily manage your files under "Gedcom"
                    in
                    the menu.
                </p>
            </div>
            <app-gedcom-upload (gedcomEvent)="gedcomUploaded($event)"></app-gedcom-upload>

            <div class="gedcom-status" *ngIf="gedcom?.length > 0">
                <p i18n class="status-title">Select GEDCOM</p>
                <div class="table-container">
                    <table mat-table [dataSource]="gedcom" class="mat-elevation-z8 order-table">
                        <!-- filename Column -->
                        <ng-container matColumnDef="filename">
                            <th i18n mat-header-cell *matHeaderCellDef> File name </th>
                            <td mat-cell *matCellDef="let element" (click)="gedcomUploaded(element.id)">
                                {{element.filename}}
                            </td>
                        </ng-container>

                        <!-- Name Column -->
                        <ng-container matColumnDef="name">
                            <th i18n mat-header-cell *matHeaderCellDef> Name </th>
                            <td mat-cell *matCellDef="let element" (click)="gedcomUploaded(element.id)">
                                {{element.name}}
                            </td>
                        </ng-container>

                        <!-- Uploaded Column -->
                        <ng-container matColumnDef="uploaded">
                            <th i18n mat-header-cell *matHeaderCellDef> Uploaded </th>
                            <td mat-cell *matCellDef="let element" (click)="gedcomUploaded(element.id)">
                                {{element.uploaded
                                | date}} </td>
                        </ng-container>

                        <!-- Persons Column -->
                        <ng-container matColumnDef="individuals">
                            <th i18n mat-header-cell *matHeaderCellDef> Individuals </th>
                            <td mat-cell *matCellDef="let element" (click)="gedcomUploaded(element.id)">
                                {{element.indis}}
                            </td>
                        </ng-container>

                        <!-- Size Column -->
                        <ng-container matColumnDef="size">
                            <th i18n mat-header-cell *matHeaderCellDef> Size </th>
                            <td mat-cell *matCellDef="let element" (click)="gedcomUploaded(element.id)">
                                {{element.size}}
                            </td>
                        </ng-container>
                        <!-- Delete Column -->
                        <ng-container matColumnDef="delete">
                            <th i18n mat-header-cell *matHeaderCellDef> </th>
                            <td mat-cell *matCellDef="let element">
                                <mat-icon (click)="delete(element)">delete</mat-icon>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="gedcom-row"></tr>
                    </table>
                </div>
            </div>
        </div>
    </mat-card-content>
</mat-card>